// Default beat-type selection for the median-beat view.
//
// Heuristic (first match wins):
//   1. dominant ∈ {n, a, j}                                       → dominant
//   2. dominant === v AND all beats are v                         → v
//   3. dominant ∈ {v, e, f, p, u} AND N-fraction ≥ 1/3            → n
//   4. fallback                                                    → dominant
//
// `beats`: array of `{i, t}` from `Annotator.annotations.beats`.
// `legendBeats`: array of `{name, color, slug}` from
// `Annotator.annotations.labels.beats` (used only to pick a sensible
// default when the recording has no beats yet).
export const computeDefaultBeatType = (beats, legendBeats = []) => {
    const legendSlugs = (legendBeats || [])
        .map((b) => b?.slug)
        .filter((s) => s && s !== "ddf")

    const nonNoise = (beats || []).filter((b) => b?.t && b.t !== "x")
    if (nonNoise.length === 0) {
        if (legendSlugs.includes("n")) return "n"
        return legendSlugs[0] || "n"
    }

    const counts = new Map()
    for (const b of nonNoise) {
        counts.set(b.t, (counts.get(b.t) || 0) + 1)
    }
    let dominant = null
    let dominantCount = -1
    for (const [slug, count] of counts) {
        if (count > dominantCount) {
            dominant = slug
            dominantCount = count
        }
    }

    if (dominant === "n" || dominant === "a" || dominant === "j") {
        return dominant
    }
    const nCount = counts.get("n") || 0
    const nFraction = nCount / nonNoise.length
    if (
        (dominant === "v" || dominant === "e" || dominant === "f" || dominant === "p" || dominant === "u")
        && nFraction >= 1 / 3
    ) {
        return "n"
    }
    return dominant
}
